// Client ID Generator Utility
// Generates unique client-side IDs for tasks

/**
 * Generates a unique client-side ID that doesn't depend on task.id
 * @returns {string} - Unique client-side ID
 */
export function generateClientSideId() {
  return `client_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Generates a temporary task ID
 * @returns {string} - Temporary task ID
 */
export function generateTempTaskId() {
  return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Generates a temporary file ID
 * @returns {string} - Temporary file ID
 */
export function generateTempFileId() {
  return `temp_file_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
